import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import { Bootstrap } from './bootstrap'
import { AppRouter } from 'router'

import { ThemeProvider } from '@mui/material/styles'

import { baseTheme } from './primsell-shared-layer/styles/theme-material/materialTheme'
import { themePrimsell } from './primsell-shared-layer/styles/theme'
import { Web3ModalProvider } from './primsell-shared-layer/core/services/web3-modal-provider'
import { WagmiProvider } from 'primsell-shared-layer/core/services/wagmi-provider'

import { store } from './store/configureStore'
import { ModalController } from './features'

const App = (): JSX.Element => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <WagmiProvider>
          <ThemeProvider theme={baseTheme}>
            <StyledThemeProvider theme={themePrimsell}>
              <Bootstrap>
                <AppRouter />
                <ModalController />
              </Bootstrap>
            </StyledThemeProvider>
          </ThemeProvider>
        </WagmiProvider>
        <Web3ModalProvider />
      </Provider>
    </BrowserRouter>
  )
}

export { App }
